import {Component, Inject} from "@angular/core";
import {ICON_SVG_ASSET_CONFIG, SvgAssetIconConfig} from "./svg-asset.models";
@Component({
  selector: 'svg-asset-showcase',
  template: `
  <ul *ngFor="let item of list">
    <li>
      <div><code>Asset name: {{item[0]}}</code></div>
      <div>
        <span [svgAssetOutlet]="item[0]"></span>
      </div>
    </li>
  </ul>
  `
})
export class SvgAssetShowcaseComponent {
  list: [string, string][] = [];
  constructor(@Inject(ICON_SVG_ASSET_CONFIG) private config: SvgAssetIconConfig) {
    this.list = Object.entries(config.svgAssets);
  }
}
